import styled, { CSSObject } from 'styled-components';

interface MenuStyledProps {
  sx?: CSSObject;
}

const MenuStyled = styled.div<MenuStyledProps>(({ theme, sx }) => ({
  background: theme.color.wfWhite,
  boxSizing: 'border-box',
  position: 'absolute',
  boxShadow: '0px 2px 7px gray',
  minWidth: 270,
  zIndex: 999999,
  ...sx,
}));

export { MenuStyled };
